import { Flex, Image, Text } from "@chakra-ui/react"
import { Link, LinkProps } from "@tanstack/react-router"

import plusIcon from "#/assets/plus-white.svg"
import { useHodlRoute, useLandingRoute } from "#/shared/hooks"

type NavigationButtonProps = {
  label: string
} & LinkProps

export default function NavigationButton({
  label,
  ...props
}: NavigationButtonProps) {
  const isHodlRoute = useHodlRoute()
  const isLandingRoute = useLandingRoute()

  if (isHodlRoute) return null

  return (
    <Link {...props}>
      <Flex
        bg="primary.black.100"
        color="primary.white.100"
        alignItems="center"
        gap={1}
        p="12px 18px"
        rounded="44px"
        className={`${label.toLowerCase()}-button`}
        sx={
          isLandingRoute
            ? {
                borderRadius: "15px",
                padding: "15px 20px",
                fontSize: "16px",
              }
            : {}
        }
      >
        {!isLandingRoute && <Image src={plusIcon} />}
        <Text variant="body">{label}</Text>
      </Flex>
    </Link>
  )
}
